import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";


export default class Changes extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Changes._name, API.RequestType.READ_ALL);
		super(props, model);
		this.model.sort='date';
		this.model.order='desc';
		this.sort='date';
		this.order='desc';
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Date Changed",
				id: "changes.date",
				width: 120,
				/** @param {Changes_Object} obj */
				accessor: obj => {
					return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Change Type",
				id: 'class',
				accessor: obj => obj.class.charAt(0).toUpperCase() + obj.class.slice(1),
			},
			{
				Header: "ID",
				id: 'entity',
				width: 100,
				accessor: "entity",
			},
			{
				Header: "User",
				accessor: "user_name",
			},
			{
				Header: "Field",
				accessor: "field",
			},
			{
				Header: "Original",
				accessor: "value_original",
			},
			{
				Header: "New",
				accessor: "value_new",
			},
			{
				Header: "Note",
				accessor: "note",
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Changes', "")}
							{this.renderHeaderRight("Changes", columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
